var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:{ loading : _vm.isLoading},attrs:{"src":_vm.imageSrc},on:{"load":function($event){_vm.isLoading = false}}})}
var staticRenderFns = []

export { render, staticRenderFns }